<template>
  <div class="notesAndDiscussionsRootBox">
    <div class="notesAndDiscussionsItem" v-for="(item,index) in dataList" :key="index">
      <img :src="require(`@/assets/icon/icon_note_discus_${index}.png`)">
      <div class="content">
        <div>{{ item.content }}</div>
        <div>{{ item.describe }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mNotesAndDiscussions",
  props: {
    dataList: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<style lang="scss" scoped>
.notesAndDiscussionsRootBox {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: calc(0.4 * var(--fontSize)) calc(0.2 * var(--fontSize));

  .notesAndDiscussionsItem {
    width: 100%;
    height: calc(1.11 * var(--fontSize));
    border-radius: calc(0.16 * var(--fontSize));
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 7px 4px rgba(207, 207, 207, 0.13);
    display: flex;
    align-items: center;
    transition: 0.5s;

    & > img {
      width: calc(0.59 * var(--fontSize));
      height: calc(0.59 * var(--fontSize));
      margin-left: calc(0.16 * var(--fontSize));
      transition: .5s;
      border-radius: calc(0.20 * var(--fontSize));
    }

    & > div.content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      height: calc(0.46 * var(--fontSize));
      margin-left: calc(0.14 * var(--fontSize));

      & > div:first-child {
        font-size: calc(0.18 * var(--fontSize));
      }

      & > div:last-child {
        font-size: calc(0.14 * var(--fontSize));
        color: #A6A6A6;
      }
    }
  }

  .notesAndDiscussionsItem:hover {
    transform: scale(1.06);

    & > img {
      box-shadow: 0 0 5px rgba(192, 191, 191, 0.31);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mNotesAndDiscussions.vue